<template>
    <div>
        <div class="ScenarioContentEditor p1" v-if="scenario" :class="{active: !!editNode}">
            <div style="height: 100%">
                <!--Header page-->
                <div class="p2">
                    <v-layout align-center class="py-12 px-16"
                              style="height: 60px; border-bottom: 1px solid #E4EDFA;">
                        <!--Name bot-->
                        <div class="display-flex align-center">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <div v-if="scenario" class="scenario-name" v-on="on">
                                        {{ scenario.name | capitalize }}
                                    </div>
                                </template>
                                <span>{{ scenario.name | capitalize }}</span>
                            </v-tooltip>
                            <div class="btn-icon ml-6" :title="$f.tc('refresh') + ' ' + $t('scenario')"
                                 @click="loadTreeData">
                                <v-icon color="#0052CC" size="24">mdi-refresh</v-icon>
                            </div>
                        </div>
                        <v-spacer></v-spacer>

                        <!--List editing user and button change mode-->
                        <!--Case role ADMIN/EDITOR-->
                        <div class="display-flex align-center mr-8" v-if="roleEditable">
                            <div v-if="scenarioMode === ScenarioMode.EDITING" class="display-flex align-center mr-6">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <div
                                            class="profile-avatar"
                                            style="background: #738093"
                                            v-on="on"
                                            v-if="editingUserList.length > 10"
                                        >
                                            +{{ editingUserList.length - 10 }}
                                        </div>
                                    </template>
                                    <div style="font-family: 'open sans',serif; font-size: 14px; padding: 6px">
                                        <div v-for="(item, index) in editingUserList" :key="item.id">
                                            <div v-if="index >= 10" class="mt-6 mb-6">
                                                {{ item.user.email }}
                                                {{ item.user.email === user.email ? `(${$f.tc('itsYou')})` : '' }}
                                            </div>
                                        </div>
                                    </div>
                                </v-tooltip>
                                <v-tooltip bottom color="#FFFFFF" v-for="(item, index) in editingUserList"
                                           :key="item.id">
                                    <template v-slot:activator="{ on }">
                                        <div
                                            class="profile-avatar"
                                            :style="[{background: item.color}]"
                                            v-on="on"
                                            @click="copyEmail(item.user.email)"
                                            v-if="index < 10"
                                        >
                                            {{ item.user.acronym }}
                                        </div>
                                    </template>
                                    <div class="display-flex align-center"
                                         style="font-family: 'open sans',serif; font-size: 14px; color: #262626; padding: 6px">
                                        <div class="profile-avatar-2" :style="[{background: item.color}]">
                                            {{ item.user.acronym }}
                                        </div>
                                        <div>
                                            <div style="font-family: 'open sans bold',serif">{{ item.user.name }}
                                                {{ item.user.email === user.email ? `(${$f.tc('itsYou')})` : '' }}
                                            </div>
                                            <div>{{ item.user.email }}</div>
                                        </div>
                                    </div>
                                </v-tooltip>
                            </div>

                            <!--Button change mode-->
                            <v-menu
                                v-model="showMenuMode"
                                :close-on-content-click="false"
                                :nudge-width="200"
                                :nudge-right="-200"
                                :nudge-top="-6"
                                offset-y
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <div v-on="on">
                                        <div class="btn-outline" v-if="scenarioMode === ScenarioMode.EDITING">
                                            <img src="/img/edit-blue.svg" alt="icon-edit-mode"
                                                 style="width: 14px; margin-right: 4px"/>
                                            {{ $f.tc('editing') }}
                                            <img src="/img/scenario/select.svg" alt="icon-menu"
                                                 style="width: 13px; margin-left: 8px"/>
                                        </div>
                                        <div class="btn-custom" v-else>
                                            <img src="/img/scenario/view.svg" alt="icon-view-mode"
                                                 style="width: 17px; margin-right: 4px"/>
                                            {{ $f.tc('viewing') }}
                                            <img src="/img/scenario/select_white.svg" alt="icon-menu"
                                                 style="width: 13px; margin-left: 8px"/>
                                        </div>
                                    </div>
                                </template>
                                <v-list>
                                    <div
                                        v-for="(item, index) in modeList"
                                        :key="item.value"
                                        @click="changeMode(item.value)"
                                    >
                                        <div class="display-flex align-start mode-item">
                                            <div style="width: 20px; text-align: center; margin-right: 6px">
                                                <img :src="item.icon" alt="icon-mode" class="mode-icon"
                                                     :style="{width: `${item.width}px`}"/>
                                            </div>
                                            <div>
                                                <div class="label">{{ item.label }}</div>
                                                <div class="description" style="font-size: 13px">{{
                                                        item.description
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                        <hr style="width: 100%; height: 1px; border: none; background-color: #d9d9d9"
                                            v-if="index !== modeList.length - 1"/>
                                    </div>
                                </v-list>
                            </v-menu>
                        </div>
                        <v-menu
                            v-model="showMenuActions"
                            :close-on-content-click="false"
                            :nudge-width="180"
                            :nudge-right="-180"
                            :nudge-top="-6"
                            offset-y
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <div v-on="on" class="btn-icon-outline-3">
                                    <v-icon color="#0052CC">mdi-dots-vertical</v-icon>
                                </div>
                            </template>
                            <v-list>
                                <div
                                    v-for="(actionsItem, idxActions) in actionsList"
                                    :key="`actions_${idxActions}`"
                                >
                                    <v-list-tile
                                        v-for="action in actionsItem"
                                        :key="action.value"
                                        @click="handleActionsBot(action.value)"
                                    >
                                        <div class="centerY">
                                            <div class="centerY" style="width: 18px; padding-top: 2px">
                                                <img v-if="action.icon" :src="action.icon"
                                                     :alt="`icon_action_{item.value}`" style="width: 100%">
                                            </div>
                                            <div class="ml-8">{{ action.label }}</div>
                                        </div>
                                    </v-list-tile>
                                    <hr
                                        v-if="idxActions !== actionsList.length - 1"
                                        style="border: none; height: 1px; background-color: #d9d9d9; margin: 6px 0;"
                                    />
                                </div>
                            </v-list>
                        </v-menu>
                    </v-layout>

                    <!--Actions bar -->
                    <v-layout align-center class="py-8 px-16" style="border-bottom: 1px solid #E4EDFA;">
                        <!--Testing-->
                        <div @click="toggleTest" class="mr-8"
                             :class="showTest ? 'btn-custom' : 'btn-custom-normal btn-test'">
                            {{ showTest ? $f.tc('quitTest') : $f.tc('test') }}
                        </div>

                        <!--Search node-->
                        <ScenarioNodeFinder
                            @change="goToNodeFinder($event)"
                            class="scenario-search-node"
                            style="flex-grow: 1"
                            :active-id="editNode ? editNode.id : null"
                        ></ScenarioNodeFinder>
                        <v-spacer></v-spacer>

                        <!--List action-->
                        <div @click="openScenarioInsight" class="btn-custom-normal mr-8"
                             v-show="scenarioSetting.version > 1">
                            {{ $f.tc('insights') }}
                        </div>
                        <div @click="openScenarioLLMSetting" class="btn-custom-normal mr-8"
                             v-show="scenarioSetting.version > 1">
                            {{ $f.tc('llm') }}
                        </div>
                        <div @click="openScenarioAudio" class="btn-custom-normal mr-8">
                            {{ $f.tc('audio') }}
                        </div>
                        <div @click="openScenarioDictionary" class="btn-custom-normal mr-8">
                            {{ $f.tc('dictionary') }}
                        </div>
                        <div @click="openScenarioVariable" class="btn-custom-normal mr-8">
                            {{ $f.tc('variable') }}
                        </div>
                        <div class="btn-custom-normal mr-8" @click="openScenarioSetting">
                            {{ $f.tc('setting') }}
                        </div>
                        <v-layout align-center class="zoom">
                            <div @click="zoomOut" class="minus">
                                <img src="/img/scenario/zoom-out.svg" alt="icon-zoom-out"/>
                            </div>
                            <div class="level">{{ config.zoom }}%</div>
                            <div @click="zoomIn" class="plus">
                                <img src="/img/scenario/zoom-in.svg" alt="icon-zoom-in"/>
                            </div>
                        </v-layout>
                    </v-layout>
                </div>

                <!--Content-->
                <v-layout class="p3" :class="{active: showTest, 'active-node': !!editNode}">
                    <!--Testing dialog-->
                    <div class="p4" :class="{active: showTest}">
                        <ScenarioTest ref="ScenarioTest" @node="changeEditNode($event)"
                                      @update-test-var="updateTestVariable"
                                      @change-visibility="changeVisibilityOfVariableView"></ScenarioTest>
                    </div>
                    <!--Variable view-->
                    <div class="p4_1" :class="{active: showTest && childVisible}">
                        <scenarioTestVariable :test-data="scenarioTestData"
                                              :test-node-name="scenarioTestVarNodeName"
                                              :test-node-type="scenarioTestVarNodeType" :is-visible="childVisible"
                                              @change-visibility="changeVisibilityOfVariableView"/>
                    </div>

                    <!--Main content-->
                    <div style="position: relative">
                        <!--Graph SVG-->
                        <div id="tree-container" class="tree-graph" v-on="treeContainerHandlers"></div>

                        <!--Full flow-->
                        <div class="full-flow" id="full-flow-bar" v-if="!focusId">
                            <v-slide-x-transition>
                                <div class="centerXY px-6" v-if="showFullFlowBar">
                                    <div class="step-flow" style="color: #3cc934;">
                                        <img src="/img/scenario/call-pickup.svg" alt="icon-call-pickup">
                                        {{ $f.tc('start') }}
                                    </div>
                                    <div class="line-flow"></div>
                                    <div class="step-flow step-btn" id="btn-init-call" @click="openInitCallDialog">
                                        <img src="/img/scenario/setting.svg" alt="icon-init-config">
                                        {{ $f.tc('initCall') }}
                                    </div>
                                    <div class="line-flow"></div>
                                    <div class="step-flow step-btn active-step">
                                        <img src="/img/scenario/scenario.svg" alt="icon-scenario">
                                        {{ $f.tc('scenario') }}
                                    </div>
                                    <div class="line-flow"></div>
                                    <div class="step-flow" style="color: #e41b23;">
                                        <img src="/img/scenario/hang-up.svg" alt="icon-hang-up">
                                        {{ $f.tc('hangUp') }}
                                    </div>
                                    <div class="line-flow"></div>
                                    <div class="step-flow step-btn" id="btn-end-call" @click="openEndCallDialog">
                                        <img src="/img/scenario/setting.svg" alt="icon-init-config">
                                        {{ $f.tc('endCall') }}
                                    </div>
                                </div>
                            </v-slide-x-transition>
                            <div
                                class="collapse-flow-bar"
                                @click="showFullFlowBar = !showFullFlowBar"
                            >
                                <img
                                    src="/img/scenario/collapse.svg"
                                    alt="icon-collapse-bar"
                                    :style="showFullFlowBar ? '' : {'transform': 'rotate(-180deg)'}"
                                    :title="$f.tc(`${showFullFlowBar ? 'close' : 'open'}ProcessingCall`)"
                                >
                            </div>
                        </div>
                    </div>
                </v-layout>
            </div>

            <!--Panel right: Node editor-->
            <div class="p5" :class="{active: !!editNode}">
                <template v-if="editNode">
                    <ProcessNodeEditor
                        v-if="editNode.type === NodeType.PROCESS"
                        :node="editNode"
                        @closePanelRight="closePanelRight"
                    ></ProcessNodeEditor>
                    <KBNodeEditor
                        v-if="editNode.type === NodeType.KB"
                        :node="editNode"
                        @closePanelRight="closePanelRight"
                    ></KBNodeEditor>
                    <PortalNodeEditor
                        v-if="editNode.type === NodeType.PORTAL"
                        :node="editNode"
                        @changeEditNode="changeEditNode($event)"
                        @closePanelRight="closePanelRight"
                    ></PortalNodeEditor>
                    <DecisionNodeEditor
                        v-if="editNode.type === NodeType.DECISION && !editNode.is_fallback"
                        :node="editNode"
                        @closePanelRight="closePanelRight"
                    ></DecisionNodeEditor>
                    <FallbackNodeEditor
                        v-if="editNode.type === NodeType.DECISION && editNode.is_fallback"
                        :node="editNode"
                        @closePanelRight="closePanelRight"
                    ></FallbackNodeEditor>
                    <LinkScenarioNodeEditor
                        v-if="editNode.type === NodeType.LINK_SCENARIO"
                        :node="editNode"
                        @closePanelRight="closePanelRight"
                    ></LinkScenarioNodeEditor>
                    <SupporterNodeEditor
                        v-if="editNode.type === NodeType.SUPPORTER"
                        :node="editNode"
                        @closePanelRight="closePanelRight"
                    ></SupporterNodeEditor>
                    <FormNodeEditor
                        v-if="editNode.type === NodeType.FORM"
                        :node="editNode"
                        @closePanelRight="closePanelRight"
                    ></FormNodeEditor>
                </template>
            </div>
        </div>

        <!--List dialogs-->
        <div v-else class="ScenarioContentEditor centerXY">
        </div>

        <!--Bar for focus mode-->
        <modal
            name="focus-mode-bar"
            :draggable="true"
            :width="150"
            :height="42"
            :pivotX="navigation ? 0.582 : 0.5"
            :pivotY="0.985"
        >
            <div class="display-flex align-center justify-center" style="height: 42px;">
                <v-tooltip top class="mr-6">
                    <template v-slot:activator="{ on }">
                        <div v-on="on" class="btn-icon-focus-mode" @click="activeNodeFocus">
                            <img src="/img/scenario/focus_2.svg" alt="icon-focus" style="transform: scale(1.1)">
                        </div>
                    </template>
                    <span>Focus node</span>
                </v-tooltip>
                <v-tooltip top class="mr-6">
                    <template v-slot:activator="{ on }">
                        <div v-on="on" class="btn-icon-focus-mode" @click="goBackHistory">
                            <img :src="'/img/scenario/go-back.svg'" alt="icon-go-back" style="padding-bottom: 2px">
                        </div>
                    </template>
                    <span>Go back node focus</span>
                </v-tooltip>
                <v-tooltip top class="mr-6">
                    <template v-slot:activator="{ on }">
                        <div v-on="on" class="btn-icon-focus-mode" @click="goForwardHistory">
                            <img :src="`/img/scenario/go-forward${isDisableBtnForwardFocus ? '-disable' : ''}.svg`"
                                 alt="icon-go-forward" style="padding-bottom: 2px">
                        </div>
                    </template>
                    <span>Go forward node focus</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <div v-on="on" class="btn-icon-focus-mode" @click="stopFocusMode">
                            <img src="/img/scenario/stop_red.svg" alt="icon-stop" style="transform: scale(1.2)">
                        </div>
                    </template>
                    <span>Stop focus mode</span>
                </v-tooltip>
            </div>
        </modal>

        <ScenarioInitCallDialog ref="ScenarioInitCallDialog"></ScenarioInitCallDialog>
        <ScenarioEndCallDialog ref="ScenarioEndCallDialog"></ScenarioEndCallDialog>
        <NodeContextMenu ref="NodeContextMenu" @select="doAction($event)"></NodeContextMenu>
        <ScenarioNodeSelectorMenu ref="ScenarioNodeSelectorMenu"></ScenarioNodeSelectorMenu>
        <ScenarioSetting ref="ScenarioSetting"></ScenarioSetting>
        <ScenarioLLMSetting ref="ScenarioLLMSetting"></ScenarioLLMSetting>
        <ScenarioNodeSelector ref="ScenarioNodeSelector"></ScenarioNodeSelector>
        <ScenarioVariable ref="ScenarioVariable"></ScenarioVariable>
        <ScenarioImport ref="ScenarioImport"></ScenarioImport>
        <ScenarioAnalytic ref="ScenarioAnalytic"></ScenarioAnalytic>
        <NLPEditor ref="NLPEditor"></NLPEditor>
        <IntentEditor ref="IntentEditor"></IntentEditor>
        <EntityEditor ref="EntityEditor"></EntityEditor>
        <SampleEditor ref="SampleEditor"></SampleEditor>
        <KeywordEditor ref="KeywordEditor"></KeywordEditor>
        <DictionaryEditor ref="DictionaryEditor"></DictionaryEditor>
        <ScenarioPermission ref="ScenarioPermission"></ScenarioPermission>
        <ScenarioSelectorContextMenu ref="ScenarioSelectorContextMenu"></ScenarioSelectorContextMenu>
        <ScenarioPermission ref="ScenarioPermission"></ScenarioPermission>
        <NoticeDeleteNode ref="NoticeDeleteNode"></NoticeDeleteNode>
        <ScenarioDictionary ref="ScenarioDictionary"></ScenarioDictionary>
        <ScenarioAudio ref="ScenarioAudio"></ScenarioAudio>
        <ScenarioInsight ref="ScenarioInsight"></ScenarioInsight>
    </div>
</template>

<script>
import ProcessNodeEditor from '@/views/Scenario/NodeEditor/process/ProcessNodeEditor'
import KBNodeEditor from '@/views/Scenario/NodeEditor/kb/KBNodeEditor'
import PortalNodeEditor from '@/views/Scenario/NodeEditor/PortalNodeEditor'
import DecisionNodeEditor from '@/views/Scenario/NodeEditor/DecisionNodeEditor'
import SupporterNodeEditor from '@/views/Scenario/NodeEditor/SupporterNodeEditor'
import ScenarioNodeSelector from '@/views/Scenario/ScenarioNodeSelector'
import NodeContextMenu from '@/views/Scenario/ScenarioNodeContextMenu'
import ScenarioSetting from '@/views/Scenario/ScenarioSetting'
import ScenarioTest from '@/views/Scenario/ScenarioTest'
import scenarioTestVariable from "@/views/Scenario/ScenarioTestVariable"
import ScenarioNodeSelectorMenu from '@/views/Scenario/ScenarioNodeSelectorMenu'
import createTree from '@/views/Scenario/draw/createTree'
import {mapState} from 'vuex'
import ScenarioService from '@/services/scenario.service'
import * as d3 from 'd3'
import FallbackNodeEditor from '@/views/Scenario/NodeEditor/FallbackNodeEditor'
import ScenarioNodeFinder from '@/views/Scenario/ScenarioNodeFinder'
import NLPEditor from '@/views/Scenario/nlp/NLPEditor'
import IntentEditor from '@/views/Scenario/nlp/IntentEditor'
import {ScenarioEventBus, ScenarioEventBusType} from '@/views/Scenario/scenario.eventbus'
import SampleEditor from '@/views/Scenario/nlp/SampleEditor'
import EntityEditor from '@/views/Scenario/nlp/EntityEditor'
import KeywordEditor from '@/views/Scenario/nlp/KeywordEditor'
import DictionaryEditor from '@/views/Scenario/nlp/DictionaryEditor'
import ScenarioVariable from '@/views/Scenario/ScenarioVariable'
import ScenarioImport from '@/views/Scenario/ScenarioImport'
import FormNodeEditor from '@/views/Scenario/NodeEditor/FormNodeEditor'
import ScenarioAnalytic from '@/views/Scenario/ScenarioAnalytic'
import ScenarioPermission from '@/views/Scenario/ScenarioPermission'
import ScenarioSelectorContextMenu from '@/views/Scenario/ScenarioSelectorContextMenu'
import LinkScenarioNodeEditor from '@/views/Scenario/NodeEditor/LinkScenarioNodeEditor'
import {actionTypes} from "@/store/actionTypes";
import NoticeDeleteNode from "@/views/Scenario/NoticeDeleteNode";
import ScenarioDictionary from "@/views/Scenario/ScenarioDictionary";
import ScenarioAudio from "@/views/Scenario/ScenarioAudio.vue";
import ScenarioInitCallDialog from "@/views/Scenario/ScenarioInitCallDialog.vue";
import ScenarioEndCallDialog from "@/views/Scenario/ScenarioEndCallDialog.vue";
import ScenarioLLMSetting from "@/views/Scenario/ScenarioLLMSetting.vue";
import ScenarioInsight from "@/views/Scenario/ScenarioInsight.vue";

const {NodeType, NodeContextMenuCode, ScenarioMode, ScenarioActionsBot, TypeBackgroundScenario} = ScenarioService

let moveRoot = {x: 0, y: 0, moving: false, mouseEnter: false}
let stopMoving = () => {
    moveRoot.moving = false
    let svg = document.getElementById('svg-tree-container')
    if (svg) svg.style.transition = 'top, left 0.3s ease'
}

export default {
    name: 'ScenarioContentEditor',
    components: {
        ScenarioLLMSetting,
        ScenarioEndCallDialog,
        ScenarioInitCallDialog,
        ScenarioAudio,
        NoticeDeleteNode,
        LinkScenarioNodeEditor,
        ScenarioSelectorContextMenu,
        ScenarioPermission,
        ScenarioAnalytic,
        FormNodeEditor,
        ScenarioImport,
        ScenarioVariable,
        DictionaryEditor,
        KeywordEditor,
        EntityEditor,
        SampleEditor,
        NLPEditor,
        ScenarioNodeFinder,
        FallbackNodeEditor,
        ProcessNodeEditor,
        KBNodeEditor,
        PortalNodeEditor,
        DecisionNodeEditor,
        SupporterNodeEditor,
        ScenarioNodeSelector,
        NodeContextMenu,
        ScenarioSetting,
        ScenarioTest,
        scenarioTestVariable,
        ScenarioNodeSelectorMenu,
        IntentEditor,
        ScenarioDictionary,
        ScenarioInsight,
    },
    data() {
        document.addEventListener('mouseup', stopMoving)
        return {
            NodeType,
            ScenarioMode,
            ScenarioActionsBot,
            TypeBackgroundScenario,
            editNode: null,
            focusNode: null,
            focusId: null,
            moveRoot: moveRoot,
            config: {
                zoom: 100,
            },
            zoomOptions: [
                {text: '25%', value: 25},
                {text: '50%', value: 50},
                {text: '75%', value: 75},
                {text: '100%', value: 100},
                {text: '125%', value: 125},
                {text: '150%', value: 150},
                {text: '175%', value: 175},
                {text: '200%', value: 200},
            ],
            viewBox: {
                width: 0,
                height: 0
            },
            treeContainerHandlers: {
                mouseenter: () => {
                    moveRoot.mouseEnter = true
                },
                mouseleave: () => {
                    moveRoot.mouseEnter = false
                },
                mousedown: e => {
                    if (e.which !== 1) {
                        return
                    }
                    let container = document.getElementById('svg-tree-container')
                    if (!container) {
                        return
                    }
                    let style = container.style
                    style.left = style.left || '0'
                    style.top = style.top || '0'
                    moveRoot.x = e.pageX
                    moveRoot.y = e.pageY
                    moveRoot.moving = true
                    container.style.transition = 'none'
                },
                mouseup: stopMoving,
                mousemove: e => {
                    if (moveRoot.moving) {
                        let style = document.getElementById('svg-tree-container').style
                        style.left = (parseInt(style.left) + e.pageX - moveRoot.x) + 'px'
                        style.top = (parseInt(style.top) + e.pageY - moveRoot.y) + 'px'
                    }
                    moveRoot.x = e.pageX
                    moveRoot.y = e.pageY
                },
                mousewheel: e => {
                    if (e.deltaY < 0) {
                        this.zoomIn()
                    } else {
                        this.zoomOut()
                    }
                }
            },
            listenerList: [],
            showMenuMode: false,
            showMenuActions: false,
            showMenuSetting: false,
            scenarioId: '',
            dataFlowNodes: null,
            stackFocusHistory: [],
            queueFocusHistory: [],
            showTest: false,
            showFullFlowBar: true,
            scenarioTestData: {},
            scenarioTestVarNodeName: "",
            scenarioTestVarNodeType: "",
            childVisible: false
        }
    },
    computed: {
        ...mapState({
            navigation: state => state.navigation,
            treeData: state => state.scenario.treeData,
            treeUpdate: state => state.scenario.treeUpdate,
            scenario: state => state.scenario.scenario,
            showAllException: state => state.scenario.showAllException,
            nodeHasPortal: state => state.scenario.nodeHasPortal,
            parentMap: state => state.scenario.parentMap,
            nodeMap: state => state.scenario.nodeMap,
            editingUser: state => state.scenario.editing_user,
            editingUserList: state => state.scenario.editingUserList,
            user: state => state.user.profile,
            scenarioSetting: state => state.scenario.scenario_setting,
            roleEditable: () => ScenarioService.isEditable(),
            roleAdminOrOwner: () => ScenarioService.isAdminOrOwner(),
            roleEditor: () => ScenarioService.isEditor(),
            useGuardrail: state => state.scenario.useGuardrail,
        }),
        isEdit() {
            return ScenarioService.isEditable() && ScenarioService.isModeEditing()
        },
        modeList() {
            return [
                {
                    icon: '/img/view-blue.svg',
                    width: 19,
                    label: this.$f.tc('viewing'),
                    value: ScenarioMode.VIEWING,
                    description: this.$f.tc('viewingDescription')
                },
                {
                    icon: '/img/edit-blue.svg',
                    width: 15,
                    label: this.$f.tc('editing'),
                    value: ScenarioMode.EDITING,
                    description: this.$f.tc('editingDescription')
                }
            ]
        },
        actionsList() {
            let actionsForEditor = [
                [
                    {
                        icon: '/img/analytic.svg',
                        label: this.$f.tc('analytic'),
                        value: ScenarioActionsBot.ANALYTIC,
                    }
                ],
                [
                    {
                        icon: '/img/debug.svg',
                        label: this.$f.tc('debug'),
                        value: ScenarioActionsBot.DEBUG,
                    },
                    {
                        icon: '/img/audit.svg',
                        label: this.$f.tc('audit'),
                        value: ScenarioActionsBot.AUDIT,
                    },
                    {
                        icon: '/img/history.svg',
                        label: this.$f.tc('history'),
                        value: ScenarioActionsBot.HISTORY,
                    }
                ]
            ]
            if (this.roleEditor) {
                return actionsForEditor
            }

            if (this.roleAdminOrOwner) {
                actionsForEditor[0].unshift({
                    icon: '/img/permission.svg',
                    label: this.$f.tc('managePermission'),
                    value: ScenarioActionsBot.MANAGE_PERMISSION,
                })
                return actionsForEditor
            }

            return [
                [{
                    icon: '/img/analytic.svg',
                    label: this.$f.tc('analytic'),
                    value: ScenarioActionsBot.ANALYTIC,
                }],
                [{
                    icon: '/img/history.svg',
                    label: this.$f.tc('history'),
                    value: ScenarioActionsBot.HISTORY,
                }]
            ]
        },
        scenarioMode() {
            if (!this.editingUser) {
                return ScenarioMode.VIEWING
            }
            return this.editingUser.is_editing ? ScenarioMode.EDITING : ScenarioMode.VIEWING
        },
        isDisableBtnForwardFocus() {
            return this.queueFocusHistory.length === 0
        },
    },
    mounted() {
        this.scenarioId = this.$route.params.scenarioId
        this.updateEditingUserList()
        this.$nextTick(() => {
            this.$store.dispatch(this.$actionTypes.NAVIGATION, false)
        })
        this.loadVariable()
        this.loadTreeData()
        this.loadNodeSettingVariable()
        this.loadDictionary()
        this.loadAudio()
        this.loadAudioEngine()
        this.loadLLMConfigs()

        let mapTypeToRef = {
            [ScenarioEventBusType.CREATE_SAMPLE]: 'SampleEditor',
            [ScenarioEventBusType.CREATE_INTENT]: 'IntentEditor',
            [ScenarioEventBusType.CREATE_ENTITY]: 'EntityEditor',
            [ScenarioEventBusType.CREATE_KEYWORD]: 'KeywordEditor',
            [ScenarioEventBusType.CREATE_DICTIONARY]: 'DictionaryEditor',
            [ScenarioEventBusType.SELECT_NODE]: 'ScenarioNodeSelector',
            [ScenarioEventBusType.IMPORT_FILE]: 'ScenarioImport',
            [ScenarioEventBusType.MANAGE_USER]: 'ScenarioPermission',
        }
        for (let i in mapTypeToRef) {
            ScenarioEventBus.$on(i, data => {
                this.$refs[mapTypeToRef[i]].open(data.item).then(result => data.resolve(result))
            })
        }

        // if router have data BOT history
        if (this.$route.params.historyBot) {
            this.openChatTest(JSON.parse(this.$route.params.historyBot))
        }
    },
    created() {
        // detect browser close tab
        window.addEventListener('beforeunload', () => {
            this.handleUpdateUserMode(false)
        })
    },
    destroyed() {
        this.$store.dispatch(this.$actionTypes.scenario.CLEAR_NLP)
        document.removeEventListener('mouseup', stopMoving)
        for (let i in ScenarioEventBusType) {
            ScenarioEventBus.$off(i)
        }
        if (this.scenarioMode === ScenarioMode.EDITING) {
            this.handleUpdateUserMode(false)
        }
    },
    methods: {
        // functions load and handle data
        loadVariable() {
            this.$store.dispatch(this.$actionTypes.scenario.GET_VARIABLE, this.scenarioId)
        },
        loadDictionary() {
            this.$store.dispatch(this.$actionTypes.scenario.GET_DICTIONARY_TTS, this.scenarioId)
        },
        loadAudio() {
            this.$store.dispatch(this.$actionTypes.scenario.GET_SCENARIO_AUDIO, this.scenarioId)
        },
        loadTreeData() {
            return this.$store.dispatch(this.$actionTypes.scenario.GET_TREE_DATA, this.scenarioId)
        },
        loadNodeSettingVariable() {
            this.$store.dispatch(this.$actionTypes.scenario.GET_NODE_SETTING_VARIABLE_LIST)
        },
        loadAudioEngine() {
            this.$store.dispatch(this.$actionTypes.scenario.GET_AUDIO_ENGINE)
        },
        loadLLMConfigs() {
            this.$store.dispatch(this.$actionTypes.scenario.GET_LLM_CONFIGS, this.scenarioId)
        },
        updateEditingUserList() {
            this.$store.dispatch(this.$actionTypes.scenario.UPDATE_EDITING_USERS, this.scenarioId).then(async () => {
                await this.$utils.sleep(60000)
                this.updateEditingUserList()
            })
        },
        handleUpdateUserMode(isEditing, isChangeMode = false) {
            if (!this.roleEditable) {
                return
            }

            this.$appService.showLoading()
            this.$store.dispatch(this.$actionTypes.scenario.CREATE_EDITING_USER, this.scenarioId).then(async () => {
                let result = await this.updateUserMode(isEditing)
                if (isChangeMode) {
                    this.$store.commit(actionTypes.scenario.EDITING_USER, result.data)
                    this.showMenuMode = false
                    await this.loadTreeData()
                }

                this.$appService.hideLoading()
            })
        },
        updateUserMode(isEditing) {
            return ScenarioService.UserModeService.update(this.scenarioId, this.editingUser.id, {
                is_editing: isEditing
            })
        },
        changeMode(value) {
            this.handleUpdateUserMode(value === ScenarioMode.EDITING, true)
        },
        copyEmail(email) {
            this.$utils.copyToClipboard(email, this.$f.tc('copyEmailSuccess'))
        },

        // functions handle for context menu
        handleActionsBot(actionType) {
            switch (actionType) {
                case ScenarioActionsBot.MANAGE_PERMISSION:
                    this.openManagePermissionEditor()
                    break
                case ScenarioActionsBot.DEBUG:
                    this.openDebugMode()
                    break
                case ScenarioActionsBot.AUDIT:
                    this.goToAudit()
                    break
                case ScenarioActionsBot.ANALYTIC:
                    this.openAnalytic()
                    break
                case ScenarioActionsBot.HISTORY:
                    this.openHistory()
                    break
            }
            this.showMenuActions = false
        },
        openManagePermissionEditor() {
            this.$refs.ScenarioPermission.open(this.scenarioId)
        },
        goToAudit() {
            this.goToURL('/scenarios/' + this.scenarioId + '/audit')
        },
        openAnalytic() {
            this.$refs.ScenarioAnalytic.open().then(
                node => {
                    this.changeEditNode(node)
                }
            )
        },
        openHistory() {
            this.goToURL(`/scenarios/${this.scenarioId}/history`)
        },
        openDebugMode() {
            this.goToURL(`/debug/${this.scenarioId}`)
        },
        goToURL(newURL) {
            if (this.$route.path !== newURL) {
                this.$router.push(newURL)
            }
        },

        // functions handle actions for layout
        drawTree() {
            let nlpSetting = this.scenarioSetting ? (this.scenarioSetting.nlp_setting ? this.scenarioSetting.nlp_setting : []) : []
            this.$nextTick(() => {
                let dataTree = createTree(
                    this.treeData,
                    'tree-container',
                    {
                        onNodeSelected: this.onNodeSelected,
                        onNodeContextMenu: this.onNodeContextMenu,
                        onSvgClick: this.onSvgClick
                    },
                    {
                        zoom: this.config.zoom,
                        activeId: this.editNode ? this.editNode.id : null,
                        focusId: this.focusId,
                        usePortal: this.scenario ? this.scenario.use_portal : false,
                        typeBackground: TypeBackgroundScenario.DOTS,
                        columnWidth: 232,
                        rowHeight: 78,
                    },
                    this.$store.state.scenario.exceptionMap,
                    nlpSetting,
                    this.scenarioSetting.version
                )
                this.viewBox = {
                    width: dataTree.width,
                    height: dataTree.height,
                }
                this.dataFlowNodes = dataTree.dataFlowNodes
            })
        },
        zoomIn() {
            if (this.config.zoom < this.zoomOptions[this.zoomOptions.length - 1].value) {
                this.config.zoom += 25
                this.zoom(this.config.zoom)
            }
        },
        zoomOut() {
            if (this.config.zoom > this.zoomOptions[0].value) {
                this.config.zoom -= 25
                this.zoom(this.config.zoom)
            }
        },
        zoom(zoom) {
            let svg = document.getElementById('svg-tree-container')
            svg.style.transition = 'all 0.3s ease'
            if (this.moveRoot.mouseEnter) {
                let svgRect = svg.getBoundingClientRect()
                let containerRect = document.getElementById('tree-container').getBoundingClientRect()
                let rate_x_left = (svgRect.x - this.moveRoot.x) / svgRect.width
                let rate_y_top = (svgRect.y - this.moveRoot.y) / svgRect.height
                let left = this.moveRoot.x + this.viewBox.width * rate_x_left * zoom / 100 - containerRect.x
                let top = this.moveRoot.y + this.viewBox.height * rate_y_top * zoom / 100 - containerRect.y
                svg.style.left = left + 'px'
                svg.style.top = top + 'px'
            }
        },
        openScenarioVariable() {
            return this.$refs.ScenarioVariable.open().then(
                scenario => {
                    this.$store.dispatch(this.$actionTypes.scenario.SCENARIO, scenario)
                    this.drawTree()
                }
            )
        },
        openScenarioDictionary() {
            return this.$refs.ScenarioDictionary.open().then(
                scenario => {
                    this.$store.dispatch(this.$actionTypes.scenario.SCENARIO, scenario)
                    this.drawTree()
                }
            )
        },
        openScenarioAudio() {
            return this.$refs.ScenarioAudio.open().then(
                scenario => {
                    this.$store.dispatch(this.$actionTypes.scenario.SCENARIO, scenario)
                    this.drawTree()
                }
            )
        },
        openScenarioSetting() {
            return this.$refs.ScenarioSetting.open().then(this.drawTree)
        },
        toggleTest() {
            this.showTest = !this.showTest
            if (this.showTest) {
                this.$nextTick(() => {
                    if (this.$refs.ScenarioTest) {
                        this.$refs.ScenarioTest.start()
                    }
                })
            } else {
                this.scenarioTestData = {}
                this.childVisible = false
            }
        },
        closePanelRight() {
            if (this.editNode) {
                this.editNode = null
            }
            this.drawTree()
        },
        openChatTest(data) {
            this.showTest = true
            this.$nextTick(() => {
                if (this.$refs.ScenarioTest) {
                    this.$refs.ScenarioTest.testHistory(data)
                }
            })
        },
        goToNodeFinder(node) {
            if (!this.focusId) {
                this.changeEditNode(node)
                return
            }
            this.$appService.confirm(this.$t('confirmExitFocusMode')).then(
                confirm => {
                    if (confirm) {
                        this.editNode = node
                        this.stopFocusMode()
                    }
                }
            )
        },

        // functions handle event for node
        onNodeSelected(d) {
            d3.event.stopPropagation()
            if (!this.editNode || this.editNode.id !== d.id) {
                this.changeEditNode(this.treeData.nodeList.find(node => node.id === d.id))
            } else {
                this.changeEditNode(null)
            }
        },
        onNodeContextMenu(d) {
            d3.event.stopPropagation()
            d3.event.preventDefault()
            let coordinate = {
                x: d3.event.clientX,
                y: d3.event.clientY
            }
            let isEdit = ScenarioService.isEditable() && ScenarioService.isModeEditing()
            this.focusNode = this.treeData.nodeList.find(node => node.id === d.id)
            this.$refs.NodeContextMenu.open(this.focusNode, coordinate, isEdit)
        },
        doAction(code) {
            switch (code) {
                case NodeContextMenuCode.ADD_PROCESS:
                    this.addNode(NodeType.PROCESS)
                    break
                case NodeContextMenuCode.ADD_DECISION:
                    this.addNode(NodeType.DECISION)
                    break
                case NodeContextMenuCode.KB_NODE:
                    this.addNode(NodeType.KB)
                    break
                case NodeContextMenuCode.ADD_FALLBACK:
                    this.addNode(NodeType.DECISION, {is_fallback: true})
                    break
                case NodeContextMenuCode.ADD_SUPPORTER:
                    this.addNode(NodeType.SUPPORTER)
                    break
                case NodeContextMenuCode.ADD_PORTAL:
                    this.addNode(NodeType.PORTAL)
                    break
                case NodeContextMenuCode.ADD_FORM:
                    this.addNode(NodeType.FORM)
                    break
                case NodeContextMenuCode.DELETE:
                    this.deleteNode()
                    break
                case NodeContextMenuCode.LINK_TO:
                    this.openLinkToNodeSelector()
                    break
                case NodeContextMenuCode.UNLINK:
                    this.openUnlinkNodeSelector()
                    break
                case NodeContextMenuCode.LINK_TO_SCENARIO:
                    this.openLinkToScenarioSelector()
                    break
                case NodeContextMenuCode.FOCUS_NODE:
                    this.queueFocusHistory = []
                    this.focusId = this.focusNode.id
                    if (this.editNode) {
                        this.changeEditNode(this.treeData.nodeList.find(node => node.id === this.focusId))
                    }
                    if (this.focusId && this.stackFocusHistory[this.stackFocusHistory.length - 1] !== this.focusId) {
                        this.stackFocusHistory.push(this.focusId)
                    }
                    let style = document.getElementById('svg-tree-container').style
                    style.left = '0px'
                    style.top = '0px'
                    this.drawTree()
                    break
                case NodeContextMenuCode.COPY_STEP:
                    this.copyStep()
                    break
                case NodeContextMenuCode.PASTE_STEP:
                    this.pasteStep()
                    break
            }
        },
        async addNode(type, data) {
            let newNode = {
                type: type,
                name: 'new node',
                is_fallback: false,
                config: {
                    cardList: []
                }
            }
            switch (type) {
                case NodeType.PROCESS:
                    newNode.config.prompt = ''
                    newNode.config.rePromptList = []
                    newNode.config.currentNlp = ''
                    let configNlpParent = this.getNlpConfigParentNode(this.focusNode)
                    if (configNlpParent) {
                        newNode.config.nlpConfig = {
                            dontUseNlp: configNlpParent.dontUseNlp,
                            label: configNlpParent.label
                        }
                    }
                    newNode.config.skipPreTTS = false
                    break
                case NodeType.KB:
                    newNode.config.prompt = ''
                    newNode.config.rePromptList = []
                    break
                case NodeType.DECISION:
                    if (data && data.is_fallback) {
                        newNode.is_fallback = true
                        newNode.name = 'fallback'
                    }
                    newNode.config.conditionList = [[]]
                    break
                case NodeType.SUPPORTER:
                    newNode.config.phoneList = []
                    break
                case NodeType.FORM:
                    newNode.config = {
                        variableList: [],
                        specialOutCondition: []
                    }
                    break
                case NodeType.PORTAL:
                    let selectedNode = await this.$refs.ScenarioNodeSelector.open(
                        this.treeData.nodeList.filter(node =>
                            node.id !== this.focusNode.id &&
                            (node.type === NodeType.PROCESS || node.type === NodeType.SUPPORTER)
                        )
                    )
                    newNode.config.id = selectedNode.id
                    break
            }
            this.$store.dispatch(this.$actionTypes.scenario.ADD_NODE, {
                scenarioId: this.scenarioId,
                model: {
                    from_node: this.focusNode.id,
                    ...newNode
                }
            }).then(
                result => {
                    newNode.id = result.id
                    this.focusNode = null
                    this.editNode = newNode
                    setTimeout(this.scrollNodeToView, 500)
                }
            )

            this.drawTree()
        },
        isBranchInMainFlow() {
            let rootNode = this.dataFlowNodes.find(i => i.id === this.treeData.startId)
            let childRoot = rootNode.children
            let idNodeFocused = this.focusNode.id
            return !(!childRoot.find(i => i.id === idNodeFocused))
        },
        validDeleteRootPortals(rootPortalNodes, deleteNodes) {
            if (rootPortalNodes.length === 0) return {
                isAllow: true
            }
            let dataChecked = {
                isAllow: true,
                invalidNodes: []
            }
            rootPortalNodes.forEach(node => {
                let countAllPortalNodes = this.treeData.nodeList.filter(i => i.config.id === node.id).length
                let countPortalNodesDelete = deleteNodes.filter(i => i.config.id === node.id).length
                if (countPortalNodesDelete < countAllPortalNodes) {
                    dataChecked.isAllow = false
                    dataChecked.invalidNodes.push({
                        nodeName: node.name,
                        countConnections: countAllPortalNodes - countPortalNodesDelete
                    })
                }
            })
            return dataChecked
        },
        isValidDeleteNode() {
            if (this.focusNode.children.length === 0) {
                // check node is root
                if (this.focusNode.id === this.treeData.startId) {
                    this.$appService.toastError(this.$t('deleteNodeNotice.nodeIsWelcome'))
                    return false
                }
                // check node is root portal
                let portalList = this.nodeHasPortal[this.focusNode.id]
                if (portalList.length > 0) {
                    this.$refs.NoticeDeleteNode.open(this.$t('deleteNodeNotice.nodeHasPortal', [portalList.length]) + '!')
                    return false
                }
                return true
            }
            // check branch belongs in main flow
            if (this.isBranchInMainFlow()) {
                this.$refs.NoticeDeleteNode.open(this.$t('deleteNodeNotice.branchInMainFlow') + '!')
                return false
            }
            // check branch have root portal
            let childNodes = this.dataFlowNodes.find(i => i.id === this.focusNode.id).children.map(i => i.data)
            let deleteNodes = [this.focusNode, ...childNodes]
            let rootPortalNodes = deleteNodes.filter(i => i.is_root_portal === true)
            let deleteRootPortal = this.validDeleteRootPortals(rootPortalNodes, deleteNodes)
            if (!deleteRootPortal.isAllow) {
                this.$refs.NoticeDeleteNode.open(this.$t('deleteNodeNotice.branchHasRootPortal'), deleteRootPortal.invalidNodes.map(i => i.nodeName))
                return false
            }

            return true
        },
        deleteNode() {
            if (!this.isValidDeleteNode()) {
                return
            }
            this.$appService.confirm(this.$t('confirmDelete', {item: this.focusNode.name})).then(
                () => {
                    // case delete branch
                    if (this.focusNode.children.length > 0) {
                        let childNodes = this.dataFlowNodes.find(i => i.id === this.focusNode.id).children.map(i => i.data)
                        let deleteNodes = [...childNodes, this.focusNode]
                        let idNodesDelete = deleteNodes.map(i => i.id)
                        this.$appService.showLoading()
                        ScenarioService.deleteListNodes(this.$route.params.scenarioId, {
                            'node_ids_delete': idNodesDelete
                        }).then(async () => {
                            if (this.editNode && this.editNode.id === this.focusNode.id) {
                                this.editNode = null
                            }
                            this.focusNode = null
                            await this.loadTreeData()
                        }).finally(() => {
                            this.drawTree()
                            this.$appService.hideLoading()
                        })
                    } else {
                        // case delete node
                        this.$appService.showLoading()
                        this.$store.dispatch(this.$actionTypes.scenario.DELETE_NODE, {
                            scenarioId: this.scenarioId,
                            id: this.focusNode.id
                        }).then(
                            () => {
                                if (this.editNode && this.editNode.id === this.focusNode.id) {
                                    this.editNode = null
                                }
                                this.focusNode = null
                            }
                        ).finally(this.$appService.hideLoading)
                    }
                }
            )
        },
        copyStep() {
            let step = this.$utils.cloneObject(this.focusNode)
            // get detail children of node copied
            let childrenIds = this.focusNode.children
            let children = []
            childrenIds.forEach(itemId => {
                let item = this.treeData.nodeList.find(i => i.id === itemId)
                if (item && item.type === NodeType.DECISION) {
                    children.push(item)
                }
            })
            step.children = children
            this.$utils.copyToClipboard(JSON.stringify(step), this.$f.tc('copyStepSuccess'))
        },
        async pasteStep() {
            // get data of steps copied
            let dataClipboard = await this.$utils.getDataClipboard()
            let stepCopied = JSON.parse(dataClipboard)

            // add node process - node parent
            let nodeTypeProcess = {
                type: NodeType.PROCESS,
                name: stepCopied.name,
                is_fallback: stepCopied.is_fallback,
                config: stepCopied.config
            }
            this.$store.dispatch(this.$actionTypes.scenario.ADD_NODE, {
                scenarioId: this.scenarioId,
                model: {
                    from_node: this.focusNode.id,
                    ...nodeTypeProcess
                }
            }).then(
                async result => {
                    this.focusNode = null
                    this.editNode = result
                    await this.addListNodes(NodeType.DECISION, result.id, stepCopied.children)
                    setTimeout(this.scrollNodeToView, 500)
                }
            ).finally(() => {
                this.drawTree()
            })
        },
        addListNodes(type, parentId, listNode) {
            return Promise.all(listNode.map(node => {
                if (node.type === NodeType.DECISION) {
                    let nodeTypeProcess = {
                        type: type,
                        name: node.name,
                        is_fallback: node.is_fallback,
                        config: node.config
                    }
                    return this.$store.dispatch(this.$actionTypes.scenario.ADD_NODE, {
                        scenarioId: this.scenarioId,
                        model: {
                            from_node: parentId,
                            ...nodeTypeProcess
                        }
                    })
                }
            }))
        },
        openLinkToScenarioSelector() {
            this.$refs.ScenarioSelectorContextMenu.open(this.focusNode).then(scenario => {
                let newNode = {
                    type: NodeType.LINK_SCENARIO,
                    name: 'link to ' + scenario.name,
                    config: {
                        scenario_id: scenario.id,
                        node_id: ''
                    }
                }
                this.$store.dispatch(this.$actionTypes.scenario.ADD_NODE, {
                    scenarioId: this.scenarioId,
                    model: {
                        from_node: this.focusNode.id,
                        ...newNode
                    }
                }).then(
                    result => {
                        newNode.id = result.id
                        this.focusNode = null
                        this.editNode = newNode
                        setTimeout(this.scrollNodeToView, 500)
                    }
                )
            })
        },
        openUnlinkNodeSelector() {
            let nodeList = this.focusNode.children.map(child => this.nodeMap[child])
            this.$refs.ScenarioNodeSelectorMenu.open(this.focusNode, nodeList).then(
                node => {
                    this.$store.dispatch(this.$actionTypes.scenario.DELETE_LINK, {
                        scenarioId: this.scenarioId,
                        fromId: this.focusNode.id,
                        toId: node.id
                    })
                    this.drawTree()
                }
            )
        },
        openLinkToNodeSelector() {
            let nodeList = this.treeData.nodeList.filter(node =>
                node.id !== this.focusNode.id &&
                (node.type !== NodeType.DECISION || (node.type === NodeType.DECISION && !this.parentMap[node.id]))
            )
            if (this.focusNode.type === NodeType.DECISION) {
                if (this.focusNode.children.length === 0) {
                    nodeList = nodeList.filter(node => node.type !== NodeType.DECISION)
                } else {
                    nodeList = []
                }
            } else if (this.focusNode.type === NodeType.PROCESS || this.focusNode.type === NodeType.KB) {
                if (this.focusNode.children.length > 0) {
                    if (this.nodeMap[this.focusNode.children[0]].type === NodeType.DECISION) {
                        nodeList = nodeList.filter(node => node.type === NodeType.DECISION)
                    } else {
                        nodeList = []
                    }
                }
            } else {
                nodeList = []
            }
            this.$refs.ScenarioNodeSelectorMenu.open(this.focusNode, nodeList).then(
                node => {
                    let sameFlow = false
                    if (!(this.parentMap[node.id] || node.id === this.scenario.start_node)) {
                        sameFlow = this.inTheSameFlow(node, this.focusNode)
                    }
                    if (this.parentMap[node.id] || node.id === this.scenario.start_node || sameFlow) {
                        let newNode = {
                            type: NodeType.PORTAL,
                            name: 'portal',
                            config: {
                                id: node.id
                            }
                        }
                        this.$store.dispatch(this.$actionTypes.scenario.ADD_NODE, {
                            scenarioId: this.scenarioId,
                            model: {
                                from_node: this.focusNode.id,
                                ...newNode
                            }
                        }).then(
                            result => {
                                newNode.id = result.id
                                this.focusNode = null
                                if (this.scenario.use_portal) {
                                    this.editNode = newNode
                                }
                                setTimeout(this.scrollNodeToView, 500)
                            }
                        )
                    } else {
                        this.$store.dispatch(this.$actionTypes.scenario.ADD_LINK, {
                            scenarioId: this.scenarioId,
                            fromId: this.focusNode.id,
                            toId: node.id
                        })
                    }
                    this.drawTree()
                }
            )
        },
        inTheSameFlow(node, focusNode) {
            let parentId = this.parentMap[focusNode.id] ? this.parentMap[focusNode.id].id : undefined
            if (!parentId) {
                return false
            }
            let parentNode = this.nodeMap[parentId]
            if (parentNode) {
                if (JSON.stringify(parentNode) === JSON.stringify(node)) {
                    return true
                } else {
                    return this.inTheSameFlow(node, parentNode)
                }
            } else return false

        },

        // list actions for focus mode
        resetHistoryFocus() {
            let style = document.getElementById('svg-tree-container').style
            style.left = '0'
            style.top = '64px'
            this.stackFocusHistory = []
            this.queueFocusHistory = []
        },
        stopFocusMode() {
            this.focusId = null
            this.resetHistoryFocus()
            this.drawTree()
        },
        goBackHistory() {
            let backNodeId = this.stackFocusHistory.pop()
            if (backNodeId) {
                this.queueFocusHistory.unshift(backNodeId)
            }
            let idx = this.stackFocusHistory.length - 1
            this.focusId = this.stackFocusHistory[idx > -1 ? idx : 0]
            if (!this.focusId) {
                this.resetHistoryFocus()
            }
            this.drawTreeFocus()
        },
        goForwardHistory() {
            let forwardNodeId = this.queueFocusHistory.shift()
            this.stackFocusHistory.push(forwardNodeId)
            this.focusId = forwardNodeId
            this.drawTreeFocus()
        },
        activeNodeFocus() {
            this.changeEditNode(this.treeData.nodeList.find(node => node.id === this.focusId))
        },
        drawTreeFocus() {
            let style = document.getElementById('svg-tree-container').style
            style.left = '0'
            style.top = this.focusId ? '0' : '64px'
            if (this.focusId && this.editNode) {
                this.changeEditNode(this.treeData.nodeList.find(node => node.id === this.focusId))
            } else {
                this.drawTree()
            }
        },

        // other functions
        getNlpConfigParentNode(nodeCurrent) {
            // Case node current is of type PROCESS
            if (nodeCurrent.type === NodeType.PROCESS) {
                return nodeCurrent.config.nlpConfig
            }
            // Case node current is of type other
            let parentNode = this.parentMap[nodeCurrent.id]
            return parentNode.config.nlpConfig ? parentNode.config.nlpConfig : null
        },
        scrollNodeToView() {
            if (!this.editNode) {
                return
            }
            let element = document.getElementById(this.editNode.id)
            let svg = document.getElementById('svg-tree-container')
            let container = document.getElementById('tree-container')
            let elementRect = element.getBoundingClientRect()
            let svgRect = svg.getBoundingClientRect()
            let containerRect = container.getBoundingClientRect()
            let is_view_x = containerRect.x < elementRect.x && elementRect.x < containerRect.x + containerRect.width
            let is_view_y = containerRect.y < elementRect.y && elementRect.y < containerRect.y + containerRect.height
            let is_view = is_view_x && is_view_y
            if (!is_view) {
                let x = containerRect.width / 2 - elementRect.x + svgRect.x
                svg.style.left = x + 'px'
                let y = containerRect.height / 2 - elementRect.y + svgRect.y
                svg.style.top = y + 'px'
            }
        },
        changeEditNode(node) {
            this.editNode = node
            this.drawTree()
            setTimeout(this.scrollNodeToView, 500)
        },

        // method for processing call bar
        openInitCallDialog() {
            this.$refs.ScenarioInitCallDialog.open()
        },
        openEndCallDialog() {
            this.$refs.ScenarioEndCallDialog.open()
        },
        openScenarioLLMSetting() {
            return this.$refs.ScenarioLLMSetting.open().then(
                scenario => {
                    this.$store.dispatch(this.$actionTypes.scenario.SCENARIO, scenario)
                    this.drawTree()
                }
            )
        },
        openScenarioInsight() {
            return this.$refs.ScenarioInsight.open().then(
                scenario => {
                    this.$store.dispatch(this.$actionTypes.scenario.SCENARIO, scenario)
                    this.drawTree()
                }
            )
        },
        changeVisibilityOfVariableView(isVisible) {
            this.childVisible = isVisible
        },
        updateTestVariable(newData, nodeName, nodeType) {
            this.scenarioTestVarNodeName = nodeName
            this.scenarioTestVarNodeType = nodeType
            if ((this.scenarioTestVarNodeType === "PROCESS") || (this.scenarioTestVarNodeType === "SUPPORTER")) {
                this.scenarioTestData = newData
                if (!this.childVisible) {
                    this.childVisible = true;
                }
            } else {
                if (this.childVisible) {
                    this.childVisible = false;
                }
            }
        }
    },
    watch: {
        config: {
            deep: true,
            handler: function () {
                this.drawTree()
            }
        },
        scenarioSetting: {
            deep: true,
            handler: function () {
                this.drawTree()
            }
        },
        treeUpdate() {
            if (this.editNode) {
                this.editNode = this.treeData.nodeList.find(node => node.id === this.editNode.id)
            }
            if (this.focusNode) {
                this.focusNode = this.treeData.nodeList.find(node => node.id === this.focusNode.id)
            }
            this.$forceUpdate()
            this.drawTree()
        },
        focusId(newVal, oldVal) {
            if (newVal) {
                this.$modal.show('focus-mode-bar')
            }

            if (oldVal && !newVal) {
                this.$modal.hide('focus-mode-bar')
            }
        },
    },
}
</script>

<style scoped lang="scss">
@import "draw/tree";
@import "scenarioLayout";

.ScenarioContentEditor {
    height: calc(100vh - 62px);
    overflow: hidden;
    position: relative;
}

.scenario-name {
    font-size: 22px;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
    max-width: 450px;
    font-family: "open sans bold", serif;
}

.scenario-search-node {
    flex-grow: 1;
    max-width: 800px;
    min-width: 500px;
}

.btn-custom-normal, .btn-custom, .btn-outline {
    line-height: 32px !important;
    font-family: "open sans semi", serif;
}

.profile-avatar, .profile-avatar-2 {
    cursor: pointer;
    height: 32px;
    width: 32px;
    margin-right: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "open sans semi", serif;
    font-size: 13px;
    color: #FFFFFF;
    border-radius: 50%;
}

.profile-avatar-2 {
    width: 48px;
    height: 48px;
    font-size: 18px;
    margin-right: 8px;
}

.text-permission {
    font-family: 'open sans', serif;
    font-size: 14px;
    background: #ffeeba;
    color: #856404;
    padding: 0 12px;
    height: 32px;
    line-height: 32px;
    border-radius: 5px;
}

.tree-graph {
    width: 100%;
    height: 100%;
    background: #fdfcff;
    padding-right: 0;
    position: relative;
    overflow: hidden;

    ::v-deep .all-scroll {
        cursor: all-scroll;
    }

    &::-webkit-scrollbar {
        display: none;
    }

    &::v-deep .svg-tree-container {
        position: absolute;
        top: 0;
        left: 0;
        transition: top, left 0.3s ease;
        z-index: 1;
    }
}

.full-flow {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 17px;
    left: 0;
    height: 49px;
    background: #FFFFFF;
    border: 1px solid #e4edfa;
    border-radius: 0 8px 8px 0;
    z-index: 2;
    font-size: 14px;
    color: #727885;
    overflow: hidden;

    .step-flow {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px 12px;
        border-radius: 5px;
        font-family: "open sans semi", serif;
        cursor: default;
        user-select: none;
        white-space: nowrap;

        img {
            margin-right: 6px;
            width: 16px;
        }
    }

    .step-btn {
        margin: 0 6px;

        &:hover {
            background: #C4DAF6;
            color: #0052CC;
            cursor: pointer;
            transition: 0.3s;
        }
    }

    .active-step {
        background: #e4edfa;
        color: #0052CC;
    }

    .line-flow {
        flex: 1;
        min-width: 50px;
        height: 1px;
        border: 1px dashed #d9d9d9;
    }

    .collapse-flow-bar {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #e4edfa;
        padding: 0 4px;
        height: 100%;
        cursor: pointer;

        img {
            width: 26px;
            transition: 0.4s;
        }
    }
}

.zoom {
    background: #fff;
    flex-grow: 0;
    border: 1px solid #D9D9D9;
    border-radius: 5px;
    height: 32px;
    overflow: hidden;

    .minus {
        border-right: 1px solid #E4EDFA;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:hover {
            background: #d9e5f7;
        }
    }

    .plus {
        border-left: 1px solid #E4EDFA;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:hover {
            background: #d9e5f7;
        }
    }

    .level {
        width: 60px;
        display: flex;
        justify-content: center;
        font-family: "open sans bold", serif;
        font-size: 14px;
    }

    img {
        width: 16px;
        height: 16px;
    }
}

.mode-item {
    padding: 6px 8px;
    font-family: "open sans", serif;
    font-size: 14px;
    margin-bottom: 6px;
    border-radius: 5px;
    cursor: pointer;

    &:hover {
        background: #EEF6FF;
        color: #0052CC;
        transition: 0.4s;
    }

    &:last-child {
        border-bottom: none;
        margin-bottom: 0;
        margin-top: 6px;
    }

    .mode-icon {
        margin-top: 4px;
    }

    .label {
        font-family: "open sans bold", serif;
        font-size: 14px;
        margin-bottom: 0 !important;
    }
}

.btn-test {
    background: #F7722F;
    border-color: #F7722F;
    color: #FFFFFF;

    &:hover {
        background: #ff8e53 !important;
        border-color: #F7722F !important;
    }
}

.btn-icon-focus-mode {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 6px;
    border-radius: 4px;

    &:not(.disable):hover {
        background: #4c5052;
    }
}

::v-deep {
    .v-tooltip__content {
        pointer-events: auto !important;
    }

    .v--modal {
        background: #3c3f41;
        border-radius: 10px;
    }

    .v--modal-overlay[data-modal="focus-mode-bar"] {
        width: 0 !important;
        height: 0 !important;
        z-index: 3 !important;
    }
}
</style>
